import { type } from "@/api/arktype";

const FUNNEL_STAGES = [
	"interest",
	"appointment",
	"consulted",
	"quoted",
	"closed",
	"post_op",
	"recurring",
	"reactivation",
	"lost",
	"not_applicable",
] as const;

const TEMPERATURES = ["hot", "warm", "cold"] as const;

export const funnelStage = type.enumerated(...FUNNEL_STAGES);
export const temperature = type.enumerated(...TEMPERATURES);
